import { Component, Input } from '@angular/core';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
  selector: 'app-expired-cell',
  standalone: true,
  template: `{{ isExpired(params.data.expiresAt) ? 'Sí' : 'No' }}`,
})
export class ExpiredCellComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any>;

  isExpired(expiresAt: string | Date | null | undefined): boolean {
    if (!expiresAt) return false;
    const now = new Date();
    return new Date(expiresAt) < now;
  }
}